import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "bg-white rounded-3xl p-3 xl:px-6" }
const _hoisted_2 = { class: "flex flex-col gap-3 items-center" }
const _hoisted_3 = { class: "font-bold text-lg" }
const _hoisted_4 = { class: "flex flex-col gap-2" }
const _hoisted_5 = { class: "flex gap-2" }
const _hoisted_6 = { class: "text-brown text-sm" }
const _hoisted_7 = { class: "text-brown text-sm" }
const _hoisted_8 = { class: "text-brown text-sm" }
const _hoisted_9 = ["placeholder"]

import GradientButton from "@/components/buttons/GradientButton.vue";
import { useI18n } from "vue-i18n";
import { MONTHS_KEYS } from "@/constants/chineseCalendar";
import AppSelect from "@/components/inputs/AppSelect.vue";
import {
  computed,
  ref,
  onBeforeMount,
} from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'BirthDateInputCard',
  props: /*@__PURE__*/_mergeModels({
    isLoading: { type: Boolean },
    initDate: {}
  }, {
    "modelValue": {
  default: null,
},
    "modelModifiers": {},
  }),
  emits: /*@__PURE__*/_mergeModels(["calculateMatrix"], ["update:modelValue"]),
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emits = __emit;
const userName = _useModel<string | null>(__props, "modelValue");

const { t } = useI18n();

const selectedDay = ref();
const selectedMonth = ref();
const selectedYear = ref();

const supportedYears = ref();
const monthDays = computed(() => {
  if (selectedMonth.value === undefined || selectedYear.value === undefined) {
    return [];
  }
  const daysInMonth = new Date(
    selectedYear.value,
    selectedMonth.value,
    0
  ).getDate();
  return Array.from({ length: daysInMonth }, (_, i) => i + 1);
});

function generateDropdownYears() {
  const startYear = selectedYear.value - 100;
  supportedYears.value = Array.from({ length: 200 }, (_, i) => startYear + i);
}

function selectCurrentDay() {
  const today = props.initDate ?? new Date();
  selectedMonth.value = today.getMonth();
  selectedYear.value = today.getFullYear();
  selectedDay.value = today.getDate();
}

onBeforeMount(() => {
  selectCurrentDay();
  generateDropdownYears();
});

function handleSubmit() {
  emits(
    "calculateMatrix",
    selectedDay.value,
    selectedMonth.value + 1,
    selectedYear.value
  );
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", _hoisted_3, _toDisplayString(_unref(t)("calculators.destiny-matrix.input-card.title")), 1),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", null, [
            _createElementVNode("p", _hoisted_6, _toDisplayString(_unref(t)("calculators.destiny-matrix.input-card.day")), 1),
            _createVNode(AppSelect, {
              class: "w-24",
              items: monthDays.value,
              "default-value": selectedDay.value,
              onSelectOption: _cache[0] || (_cache[0] = (newSelectedDay) => selectedDay.value = newSelectedDay)
            }, null, 8, ["items", "default-value"])
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("p", _hoisted_7, _toDisplayString(_unref(t)("calculators.destiny-matrix.input-card.month")), 1),
            _createVNode(AppSelect, {
              class: "w-32",
              items: _unref(MONTHS_KEYS),
              "default-value": _unref(MONTHS_KEYS)[selectedMonth.value],
              onSelectOption: _cache[1] || (_cache[1] = (newSelectedMonth) => selectedMonth.value = _unref(MONTHS_KEYS).indexOf(newSelectedMonth))
            }, {
              option: _withCtx(({ item }) => [
                _createTextVNode(_toDisplayString(_unref(t)(`months.${item}`)), 1)
              ]),
              _: 1
            }, 8, ["items", "default-value"])
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("p", _hoisted_8, _toDisplayString(_unref(t)("calculators.destiny-matrix.input-card.year")), 1),
            _createVNode(AppSelect, {
              class: "w-24",
              items: supportedYears.value,
              "default-value": selectedYear.value,
              onSelectOption: _cache[2] || (_cache[2] = (newSelectedYear) => selectedYear.value = newSelectedYear)
            }, null, 8, ["items", "default-value"])
          ])
        ]),
        _withDirectives(_createElementVNode("input", {
          class: "w-full h-[52px] rounded-[14px] border border-muted px-4 text-brown focus:outline-none sf-pro",
          type: "text",
          placeholder: _unref(t)('calculators.destiny-matrix.input-card.name_input'),
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((userName).value = $event))
        }, null, 8, _hoisted_9), [
          [_vModelText, userName.value]
        ])
      ]),
      _createVNode(GradientButton, {
        class: "w-[153px] h-[46px] md:w-[191px] md:h-14",
        "bg-color": "bg-brown-gradient",
        "hover-bg-color": "bg-orange-gradient",
        text: _unref(t)('buttons.calculate'),
        onClick: handleSubmit,
        "is-loading": __props.isLoading
      }, null, 8, ["text", "is-loading"])
    ])
  ]))
}
}

})